import React, { AnchorHTMLAttributes } from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import * as styles from '../button/button.module.scss';

export interface ButtonLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  hasIcon?: boolean;
}

const ButtonLink = ({
  className,
  children,
  hasIcon,
  href,
  ...htmlAnchorProps
}: ButtonLinkProps) => {
  const isExternal = href && /^(https?:|mailto:|tel:)/.test(href);

  const props = {
    ...htmlAnchorProps,
    className: classnames(
      styles.root,
      {
        [styles.hasIcon]: hasIcon,
        [styles.isDisabled]: !href,
      },
      className
    ),
  };

  if (!href) {
    return <span {...props}>{children}</span>;
  }

  if (isExternal) {
    return (
      <a {...props} href={href}>
        {children}
      </a>
    );
  }

  return (
    <Link {...props} to={href}>
      {children}
    </Link>
  );
};

export default ButtonLink;
